import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'mobx-react';
import App from './App.js';
import { timerStore } from './store/Store.js';
import { init, Replay, BrowserTracing } from '@sentry/browser';

import 'remixicon/fonts/remixicon.css';
import './index.css';
import './layout.css';

if (window.location.hostname !== 'localhost') {
  init({
    ignoreErrors: ['AxiosError: Request aborted'],
    dsn: 'https://7833934f731a66ff31c07f7bd3d29e93@o292914.ingest.sentry.io/4505911306944512',
    integrations: [
      new BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [/^https:\/\/jirango\.com/],
      }),
      // new Replay(),
    ],
    // Performance Monitoring
    // tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // // Session Replay
    // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={timerStore}>
      <App />
    </Provider>
  </React.StrictMode>
);
